import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {deleteManyDvr, deleteManyDvrFailure, deleteManyDvrSuccess} from './dvr.delete-many.actions';
import {DvrService} from '../../../services/api/dvr/dvr.service';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';
import {loadRecords, manyRecordsDeleted} from '../actions/records.actions';


@Injectable()
export class DvrDeleteManyEffects {

  // noinspection JSUnusedGlobalSymbols
  deleteManyDvr$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyDvr),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<DvrRecord>[] = ids
            .map((id: UUID): Observable<DvrRecord> =>
              this.service.deleteRecord({recordId: id, shouldRemoveFile: true})
            );

          return forkJoin(requests)
            .pipe(
              map(() => deleteManyDvrSuccess({ids: ids})),
              catchError((error: any) => of(deleteManyDvrFailure({error: error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyDvrSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyDvrSuccess),
        tap(() =>
          this.snackBar.open('Records successfully deleted', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) => manyRecordsDeleted({ids: data.ids}))
      );
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyDvrFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyDvrFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to delete records: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadRecords())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: DvrService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
